var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Moving"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 21.798H4.5V10.798H6.5V19.798H18.5V10.798H20.5V21.798ZM3.5 3.79803H21.5V9.79803H3.5V3.79803ZM10 11.798H15C15.28 11.798 15.5 12.018 15.5 12.298V13.798H9.5V12.298C9.5 12.018 9.72 11.798 10 11.798ZM5.5 5.79803V7.79803H19.5V5.79803H5.5Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.5 3.79803H21.5V9.79803H3.5V3.79803ZM5.5 5.79803V7.79803H19.5V5.79803H5.5Z",
    fill: "#14AA3C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario16);
export default __webpack_public_path__ + "static/media/Scenario16.581190471310b681d49fcb9994f28770.svg";
export { ForwardRef as ReactComponent };